'use client';

/**
 * При переходах между страницами на app и pages роутерах логика роутинга next может ломаться.
 * Поэтому на данный момент для таких переходов используется прямое изменение пути в адресной строке.
 */
const navigateBetweenRouters = (path: string) => {
  window.location.href = path;
};

export default navigateBetweenRouters;
